import Organisation from '@/models/Organisation';
import { IOrganisationState } from '@/modules/organisation/store/state';
import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import { OrganisationUser } from '../types';

/*--------------------------------------------------/
 * Organisation Mutations
 *--------------------------------------------------*/
export const OrganisationMutations: IOrganisationMutations = {
  [MT.SET_CURRENT_ORGANISATION]: (
    state: IOrganisationState,
    organisation: Organisation
  ) => (state.organisation = organisation),
  [MT.SET_ORGANISATION_NAVBAR]: (
    state: IOrganisationState,
    orgNavbar: boolean
  ) => (state.orgNavbar = orgNavbar),
  [MT.SET_ORGANISATION_USER]: (
    state: IOrganisationState,
    organisationUser: OrganisationUser
  ) => (state.organisationUser = organisationUser),
  [MT.SET_LOADER]: (state: IOrganisationState, loader: boolean) =>
    (state.loader = loader)
};

/*--------------------------------------------------/
 * Organisation Mutations Tree Interface
 *--------------------------------------------------*/
export interface IOrganisationMutations
  extends MutationTree<IOrganisationState> {
  [MT.SET_CURRENT_ORGANISATION]: (
    state: IOrganisationState,
    organisation: Organisation
  ) => void;
  [MT.SET_ORGANISATION_NAVBAR](
    state: IOrganisationState,
    orgNavbar: boolean
  ): void;
  [MT.SET_ORGANISATION_USER](
    state: IOrganisationState,
    organisationUser: OrganisationUser
  ): void;
  [MT.SET_LOADER](state: IOrganisationState, loader: boolean): void;
}
